// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ClientsManagementQueries } from '../../../../types/server/modules/clientsManagement/queries';

export type * from '../../../../types/server/modules/clientsManagement/queries';

export const createQueries = ( requests: Requests ): ClientsManagementQueries => ({
  AccountsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/accounts-readmodel/${id}`, query, headers ); 
        },
  AccountsReadmodel: ( params?, headers? ) => {
        return requests.get( `/accounts-readmodel/:id?`, params, headers );
      },
  AccountsNonPaymentSuspensionById: ( id, query, headers ) => { 
          return requests.get( `/accounts/non-payment-suspension/${id}`, query, headers ); 
        },
  AccountsNonPaymentSuspension: ( params?, headers? ) => {
        return requests.get( `/accounts/non-payment-suspension/:id?`, params, headers );
      },
  AccountsSuspensionStatus: ( params?, headers? ) => {
        return requests.get( `/accounts/suspension-status`, params, headers );
      },
  AccountsObservationState: ( params?, headers? ) => {
        return requests.get( `/accounts/observation-state`, params, headers );
      },
  SubscriptionPlansReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/subscription-plans-readmodel/${id}`, query, headers ); 
        },
  SubscriptionPlansReadmodel: ( params?, headers? ) => {
        return requests.get( `/subscription-plans-readmodel/:id?`, params, headers );
      },
  ClientsManagementConfigurationReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/clients-management-configuration-readmodel/${id}`, query, headers ); 
        },
  ClientsManagementConfigurationReadmodel: ( params?, headers? ) => {
        return requests.get( `/clients-management-configuration-readmodel/:id?`, params, headers );
      },
  UsersProfilesMe: ( params?, headers? ) => {
        return requests.get( `/users-profiles/me`, params, headers );
      },
  GetLoginUser: ( params?, headers? ) => {
        return requests.get( `/get-login-user/:userId`, params, headers );
      },
  UsersProfilesById: ( id, query, headers ) => { 
          return requests.get( `/users-profiles/${id}`, query, headers ); 
        },
  UsersProfiles: ( params?, headers? ) => {
        return requests.get( `/users-profiles/:id?`, params, headers );
      },
  UserPreferencesById: ( id, query, headers ) => { 
          return requests.get( `/user-preferences/${id}`, query, headers ); 
        },
  UserPreferences: ( params?, headers? ) => {
        return requests.get( `/user-preferences/:id?`, params, headers );
      },
  AssignmentGroupsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/assignment-groups-readmodel/${id}`, query, headers ); 
        },
  AssignmentGroupsReadmodel: ( params?, headers? ) => {
        return requests.get( `/assignment-groups-readmodel/:id?`, params, headers );
      }
});
